import { memo, useEffect, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { accountsApprovedFetchAction } from '../../../../store/fetchActions/userAccounts';
import { userFetchAction } from '../../../../store/fetchActions/usersActions';
import { detailAccountsFetchAction, exportAccountsFetchAction } from '../../../../store/fetchActions/accountActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../components/Filter/Filter';
import DateInput from '../../../../components/DateInput';
import Button from '../../../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import { FiFileText } from 'react-icons/fi';
import formatMoneyBRL from '../../../../utils/functions/formatMoneyBRL';
import SelectOptions from '../../../../components/SelectOptions';
import formatCPF from '../../../../utils/functions/formatCPF';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';
import { useForm } from 'react-hook-form';
import { FirstFilterLine, SecondFilterLine } from '../../../../components/Filter/Filter.styles';
import useCallFilter from '../../../../utils/hooks/useCallFilter';
import * as dayjs from 'dayjs';
import TextField from '../../../../components/TextField';
import Loading from '../../../../components/Loading';
import moment from 'moment';
import { useTheme } from 'styled-components';
import ModalContasAprovadas from '../Modals/ContasAprovadas';
import { pagesOptions } from '../../../../utils/constant';

function UsuariosAprovados({ value, index }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));
  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    LIMIT: 10,
    PAGE: 1,
  });
  const [myExport, setExport] = useState(false);
  const [aprovedClient, setAprovedClient] = useState();
  const [accountId, setAccountId] = useState();


  const {
    approvedAccountsData,
    paginationApprovedAccounts,
    loadingApprovedAccounts,
    errorApprovedAccounts,
    errorMessageApprovedAccounts,
  } = useSelector((state) => state.userAccounts);

  useCallFilter(filterData, setFilter, accountsApprovedFetchAction, value, index);

  const { handleSubmit, control, reset } = useForm({});

  const header = [
    {
      id: 'dataAprovacao',
      name: 'DATA DE APROVAÇÃO',
      align: 'center',
    },
    {
      id: 'CPFCNPJ',
      name: 'CPF/CNPJ',
      align: 'left',
    },
    {
      id: 'nome',
      name: 'NOME/RAZÃO SOCIAL',
      align: 'left',
    },
    {
      id: 'agencia',
      name: 'AGÊNCIA',
      align: 'center',
    },
    {
      id: 'conta ',
      name: 'CONTA',
      align: 'left',
    },
    {
      id: 'saldo',
      name: 'SALDO',
      align: 'left',
    },
  ];

  const body = approvedAccountsData?.map((val) => {
    return {
      data: [
        {
          info: dayjs(val.DT_ABERTURA).format('DD/MM/YYYY') || '-----',
          align: 'center',
        },
        {
          info: val.CPFCNPJ?.length === 11 ? formatCPF(val.CPFCNPJ) : formatCNPJ(val.CPFCNPJ),
          align: 'left',
        },
        { info: val.NOME, align: 'left' },
        { info: val.AGENCIA ?? '-----', align: 'center' },
        { info: val.CONTA, align: 'left' },
        { info: 'R$ ' + formatMoneyBRL(val.SALDO), align: 'left' },
      ],
      onClick: () => {
        inspectUser(val.CPFCNPJ, val.ID, val.ID_PRODUTO_DIGITAL);
        setAprovedClient(val.DT_INSERT);
        setAccountId(val.ID);
      },
    };
  });
 

  const filterTable = (data) => {
    data.DATA_INICIAL = dateInicial;
    data.DATA_FINAL = dateFinal;
    setFilterData(data);

    myExport && dispatch(exportAccountsFetchAction(data));
  };

  function inspectUser(id, accountId, idDigitalProduct) {
    dispatch(userFetchAction({CPFCNPJ: id, ID_PRODUTO_DIGITAL: idDigitalProduct}, 'willBeLoaded'));
    dispatch(detailAccountsFetchAction(accountId))
    setIsModalInfoOpen(true);
  }

  const closeModalContasAprovadas = () => {
    dispatch(accountsApprovedFetchAction(filterTable))
    setIsModalInfoOpen(false)
  }

  useEffect(() => {
    dispatch(accountsApprovedFetchAction(filter));
  }, [filter.PAGE]);

  return (
    <div>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextField label="Nome, CPF/CNPJ ou Conta" name={'SEARCH'} width={'25.042vw'} control={control} />
            <DateInput
              label="Data Inicial"
              name={'DATA_INICIAL'}
              control={control}
              value={dateInicial}
              onChange={(newValue) =>
                newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
              }
            />
            <DateInput
              label="Data Final"
              name={'DATA_FINAL'}
              control={control}
              value={dateFinal}
              onChange={(newValue) =>
                newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
              }
            />
            <Button
              backgroundcolor={theme.colors.buttonSearch}
              width="12.153vw"
              hoverbgcolor={theme.colors.buttonSearchHover}
              hovercolor={theme.colors.buttonSearchHoverText}
              mycolor={theme.colors.buttonSearchText}
              type="submit"
              margin={'0 1.389vw 0 0'}
              onClick={() => setExport(false)}
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
            <Button
              backgroundcolor={theme.colors.buttonSearch}
              width="12.153vw"
              hoverbgcolor={theme.colors.buttonSearchHover}
              hovercolor={theme.colors.buttonSearchHoverText}
              type="submit"
              mycolor={theme.colors.buttonSearchText}
              margin={'0 1.389vw 0 0'}
              onClick={() => setExport(true)}
            >
              <FiFileText className="default-svg" size={'1.181vw'} />
              <span>Exportar</span>
            </Button>
          </FirstFilterLine>
          <SecondFilterLine>
            <h5>Resultados por página</h5>
            <SelectOptions control={control} options={pagesOptions} name={'LIMIT'} initialValue={10} />
            <h5>Total de resultados: {paginationApprovedAccounts?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>

      {loadingApprovedAccounts ? (
        <Loading />
      ) : (
        <Table
          error={errorApprovedAccounts}
          hasPagination={true}
          filter={filter}
          pagination={paginationApprovedAccounts}
          setFilter={setFilter}
          errorMessage={errorMessageApprovedAccounts}
          filterTable={filterTable}
          header={header}
          body={body}
        />
      )}

      {isModalInfoOpen && (
        <ModalContasAprovadas open={isModalInfoOpen} close={closeModalContasAprovadas} info={aprovedClient} accountId={accountId} />
      )}
    </div>
  );
}

export default memo(UsuariosAprovados);
